import { Component, Input } from '@angular/core';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-generic-dashboard',
  templateUrl: './generic-dashboard.component.html',
  styleUrls: ['./generic-dashboard.component.scss']
})
export class GenericDashboardComponent {

    @Input() dashboardConfigarations: any
    isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  
    cardsCountsData: any;
    barChartData: { category: string; value: number }[] = [];
    doughnutChartData: { category: string; value: number }[] = [];

    constructor(private api: SevaProfileService) {
     
    }

  ngOnInit(): void {
    this.api
      .apiCall(this.dashboardConfigarations.cardsUrlEndPoints, 'GET')
      .subscribe((response: any) => {
        const data = response?.Data ?? response?.data ?? response;

        // New GAO dashboard shape: Data.Summary (backend GAODashboardViewEntity)
        if (data && (data.Summary || data.summary)) {
          const summary = data.Summary ?? data.summary;
          this.cardsCountsData = summary;

          // Build chart data from GAO dashboard view (StateStatusCounts / AgingBuckets)
          const stateStatus = data.StateStatusCounts ?? data.stateStatusCounts ?? [];
          const aging = data.AgingBuckets ?? data.agingBuckets ?? [];

          this.barChartData = stateStatus.map((row: any) => ({
            category: `${row.ApplicationTypeName ?? ''} - ${row.ApplicationStateTitle ?? ''}`.trim(),
            value: Number(row.TotalCount ?? 0)
          }));

          this.doughnutChartData = aging.map((row: any) => ({
            category: row.BucketName ?? '',
            value: Number(row.TotalCount ?? 0)
          }));
        } else {
          // Backward compatibility: Data itself has the card fields
          this.cardsCountsData = data;
        }
      });
  }


}
